import { useQuoteStore } from 'store'
import { DefineComponentProps } from 'utils'
import { CharComp } from './CharComp'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { CancelOrder } from '@/views/SpotTrade/OrderList/CancelOrder'
import './EntrustOrderCoinInfo.scss'

interface EntrustOrderCoinInfoProps {
  order: ApiResponse.SpotOrderItem
}

export const EntrustOrderCoinInfo = defineComponent<EntrustOrderCoinInfoProps>({
  props: DefineComponentProps<EntrustOrderCoinInfoProps>(['order']),
  setup(props) {
    const quoteStore = useQuoteStore()
    const { t } = useI18n()
    const coinIcon = computed(() => {
      const url = quoteStore.getCoinIconBySymbolId(props.order.symbolId)
      return url || ''
    })

    return () => {
      return (
        <div class="entrust-order-coin-info-layout">
          <img width={24} height={24} src={coinIcon.value} alt="coin icon" />
          <div class="coin-info">
            <div class="coin-name">{props.order.symbolName}</div>
            <CharComp
              class={classNames('side', {
                up: props.order.side === 'buy',
                down: props.order.side === 'sell',
              })}
            >
              {props.order.side === 'buy' ? t('买') : t('卖')}
            </CharComp>
          </div>
          <div class="text-cancel-button">
            <CancelOrder order={props.order} />
          </div>
        </div>
      )
    }
  },
})
